const AcademicWizardsIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
    <path
      opacity="0.4"
      d="M8 8V28.5375C8.5875 28.2 9.26875 28 10 28H31C31.55 28 32 27.55 32 27V7C32 6.45 31.55 6 31 6H10C8.89375 6 8 6.89375 8 8ZM14 13C14 12.45 14.45 12 15 12H27C27.55 12 28 12.45 28 13C28 13.55 27.55 14 27 14H15C14.45 14 14 13.55 14 13ZM14 19C14 18.45 14.45 18 15 18H27C27.55 18 28 18.45 28 19C28 19.55 27.55 20 27 20H15C14.45 20 14 19.55 14 19Z"
      fill="#FDC8D3"
    />
    <path
      d="M6 8C6 5.79375 7.79375 4 10 4H31C32.6562 4 34 5.34375 34 7V27C34 28.3062 33.1625 29.4187 32 29.8312V34H33C33.55 34 34 34.45 34 35C34 35.55 33.55 36 33 36H10C7.79375 36 6 34.2062 6 32V8ZM10 30C8.89375 30 8 30.8937 8 32C8 33.1063 8.89375 34 10 34H30V30H10ZM8 28.5375C8.5875 28.2 9.26875 28 10 28H31C31.55 28 32 27.55 32 27V7C32 6.45 31.55 6 31 6H10C8.89375 6 8 6.89375 8 8V28.5375ZM15 12H27C27.55 12 28 12.45 28 13C28 13.55 27.55 14 27 14H15C14.45 14 14 13.55 14 13C14 12.45 14.45 12 15 12ZM15 18H27C27.55 18 28 18.45 28 19C28 19.55 27.55 20 27 20H15C14.45 20 14 19.55 14 19C14 18.45 14.45 18 15 18Z"
      fill="#374151"
    />
  </svg>
);

export default AcademicWizardsIcon;
